import React from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { t } from '../../i18n';

const EmptyState = ({
  title = 'Aún no hay información',
  description = '',
  checklist = [],
  primaryAction = null,
  secondaryAction = null
}) => {
  const { setActivePage } = useAppContext();

  const renderAction = (action, tone) => {
    if (!action) return null;
    const classes =
      tone === 'primary'
        ? 'bg-brand-600 text-white border-brand-600 hover:bg-brand-700'
        : 'border-neutral-300 text-neutral-700 hover:bg-neutral-50';
    return (
      <button
        type="button"
        className={`inline-flex items-center gap-1.5 h-8 px-3 rounded border text-sm font-medium transition-colors ${classes}`}
        onClick={() => {
          if (action.pageId) setActivePage(action.pageId);
          action.onClick?.();
        }}
      >
        {t(action.label)}
        <ArrowRight className="w-3.5 h-3.5" />
      </button>
    );
  };

  return (
    <div className="bg-white border border-neutral-200 rounded p-5">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-4 h-4 text-warning-600 mt-0.5 shrink-0" />
        <div className="flex-1">
          <h1 className="text-lg font-semibold text-neutral-900">{t(title)}</h1>
          {description ? <p className="text-sm text-neutral-600 mt-1.5">{t(description)}</p> : null}
          {Array.isArray(checklist) && checklist.length > 0 ? (
            <ul className="mt-2.5 text-sm text-neutral-700 list-disc pl-5 space-y-1">
              {checklist.map((item) => (
                <li key={item}>{t(item)}</li>
              ))}
            </ul>
          ) : null}
          {(primaryAction || secondaryAction) && (
            <div className="mt-4 flex flex-wrap gap-2">
              {renderAction(primaryAction, 'primary')}
              {renderAction(secondaryAction, 'secondary')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;

